import React, { useEffect } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import { useRef } from "react";
import UsanseForm from "./UsanceForm";
import { useState } from "react";
import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogContentText, Switch, Toolbar, Tooltip, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";


const Usanse = () => {
    const gridRef = useRef()
    const childRef = useRef()
    const [openUsanse, setOpenUsanse] = useState(false)
    const [rowData, setRowData] = useState()
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [error, setError] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(true);

    const handledisActive = (props) => {
        return <Switch size={'small'} checked={props.value} />
    }
    const [columnDefs, setColumnDefs] = useState([
        { field: 'noOfDays', headerName: 'Number Of Days' },
        { field: 'description', headerName: 'Description', minWidth: 200, },
        { field: 'isActive', headerName: 'Active', minWidth: 200, cellRenderer: handledisActive },
    ])
    const UsanceUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.usances}`;
    const handleAddButton = () => {
        setOpenUsanse(true)
    }

    const loadUsanceData = async () => {
        try {
            let list = await OAuthService.getList(UsanceUrl);
            if (list.data) {
                const listData = list.data._embedded.usances.map((data) => {
                    data.noOfDays = data.noOfDays,
                        data.description = data.description,
                        data.isActive = data.isActive
                    return data
                })
                setRowData(listData)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
        }
    }

    const onGridReady = () => {
        loadUsanceData()
    }

    const handleSave = () => {
        const childelement = childRef.current;
        const submitData = childelement.handleSubmit();
        submitData.then((val) => {
            if (val) {
                handleFormClose()
                loadUsanceData();
            }
        })
    }

    const handleFormClose = () => {
        setOpenUsanse(false);
    }

    const handlecreateSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
            setSnackState(true)
        } else {
            setSnackState(false)
        }
    }

    const closeOpenUsance = () => {
        setOpenUsanse(false);
    }

    const onSelectionChanged = (params) => {
        let select = params.api.getSelectedRows()
        setSelectedRows(select);
    }

    const handleEdit = () => {
        setOpenUsanse(true)
    }


    const handleDeleteUsance = async () => {
        const id = selectedRows.length > 0 && selectedRows[0]._links?.self?.href.split('/').pop();
        try {
            const deleteUsance = await OAuthService.deleteData(UsanceUrl, id)

            if (deleteUsance?.data) {
                loadUsanceData();
                setSuccessMsg("Usance deleted successfully.")
                setSnackState(true)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const checkSaveDisabled = (value) => {
        setSaveDisabled(value)
    }
    
    useEffect(()=>{
        checkSaveDisabled()
    },[])

    const usanseInputField = () => {
        return <>
            <Tooltip title={"Add Usanse"}>
                <Button
                    variant="contained"
                    color="warning"
                    style={{ marginLeft: "4px" }}
                    onClick={handleAddButton}
                >
                    <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                </Button>
            </Tooltip>
            {(selectedRows && selectedRows.length > 0) &&
                <>
                    <Tooltip title={"Edit Usance"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleEdit}
                        >
                            <FuseSvgIcon>material-solid:edit</FuseSvgIcon>
                        </Button>
                    </Tooltip>
                </>
            }
        </>
    }
    return (
        <>
            <ListPageHeader
                componentName={'Usanse'}
                pageName={'Usanse'}
                headerInputFields={usanseInputField()}
                gridRef={gridRef}
                successMsg={successMsg}
                deleteDisable={selectedRows.length > 0 ? false :true}
                handlePurge={handleDeleteUsance}
                snackState={snackState}
            />
            <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                onSelectionChanged={onSelectionChanged}
                onGridReady={onGridReady}

            />
            <Dialog
                fullWidth={true}
                PaperProps={{
                    sx: {
                        minHeight: 200,
                        Width: 150
                    }
                }}
                maxWidth={'sm'}
                onClose={handleFormClose}
                open={openUsanse}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                        {(selectedRows && selectedRows.length > 0) ? "Update Usance" : "Add Usance"}
                        </Typography>
                        <Button onClick={handleFormClose}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <UsanseForm
                        open={openUsanse}
                        ref={childRef}
                        handleClose={closeOpenUsance}
                        successMsg={handlecreateSuccessMsg}
                        select={selectedRows}
                        checkSaveDisabled={checkSaveDisabled} />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSave}
                        disabled={saveDisabled}
                    >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default Usanse